var service;
export function updateConfig(config) {
  service = config
}
export default service
